var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"formater-file"},[_c('span',{staticClass:"fmt fmt-close",attrs:{"title":_vm.$t('remove')},on:{"click":function($event){return _vm.remove()}}}),_vm._v(" "),_c('div',{staticClass:"file-container"},[_c('i',{staticClass:"fmt fmt-file"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.filename))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }